import React from "react";
import classNames from "classnames";
import { Bars3BottomRightIcon } from "@heroicons/react/24/outline";

interface FloatingNotesButtonProps {
  whiteLabelStyle: any;
  onClick: () => void;
}

const FloatingNotesButton = ({
  whiteLabelStyle,
  onClick
}: FloatingNotesButtonProps) => {
  return (
    <div className="fixed bottom-12 right-[5%]">
      <button
        className={classNames(
          "px-4 py-2 border-2  rounded-lg text-sm font-medium bg-white z-10 shadow-lg flex items-center justify-center",
          whiteLabelStyle?.theme?.color?.border || "border-indigo-600",
          whiteLabelStyle?.theme?.color?.text || "text-indigo-600"
        )}
        onClick={onClick}
      >
        <Bars3BottomRightIcon className="w-4 h-4 mr-2 text-inherit" />
        Notes
      </button>
    </div>
  );
};

export default FloatingNotesButton;
